const SEARCH_API = '/sitecore/api/ssc/isagenix/searchapi/1';

export async function searchProducts(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${SEARCH_API}/GetProducts`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function searchResources(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${SEARCH_API}/GetResources`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}
